
{
  "familyId": "GET-PROC-AFNAME",
  "questions": [
    {
      "id": "GET-PROC-AFNAME-001",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een laptop kost €800. Je krijgt 20% korting. Wat betaal je?",
      "options": [
        "€640",
        "€780",
        "€600",
        "€160"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "proc_afname_korting",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Strategie: bereken de korting en trek af. Stap 1: 20% van €800 = 0,20 × 800 = €160. Stap 2: €800 − €160 = €640. Of direct: €800 × 0,80 = €640.",
        "distractorExplanations": {
          "0": "Goed! 20% van 800 = 160. Je betaalt: 800 − 160 = €640.",
          "1": "Veelgemaakte fout: 20 aftrekken in plaats van 20%. 20% van 800 = 160, niet 20.",
          "2": "Veelgemaakte fout: 25% berekenen. 25% van 800 = 200, 800 − 200 = 600. Maar het is 20%.",
          "3": "Veelgemaakte fout: alleen de korting geven. €160 is de korting, niet wat je betaalt."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-002",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Met welke factor vermenigvuldig je bij een afname van 30%?",
      "options": [
        "0,70",
        "0,30",
        "1,30",
        "0,07"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "proc_afname_factor",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: afname-factor = 1 − percentage als decimaal. Stap 1: 30% = 0,30. Stap 2: Factor = 1 − 0,30 = 0,70.",
        "distractorExplanations": {
          "0": "Goed! Afname van 30% → factor = 1 − 0,30 = 0,70.",
          "1": "Veelgemaakte fout: alleen het percentage als decimaal. 0,30 is de afname, niet de factor. Factor = 1 − 0,30 = 0,70.",
          "2": "Veelgemaakte fout: optellen in plaats van aftrekken. 1 + 0,30 = 1,30 is een toename-factor, niet afname.",
          "3": "Veelgemaakte fout: 3% en 30% verwarren. 30% = 0,30, factor = 0,70."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-003",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een auto is €15.000 waard. Na een jaar is de waarde met 12% gedaald. Wat is de auto nu waard?",
      "options": [
        "€13.200",
        "€13.800",
        "€3.000",
        "€16.800"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "proc_afname_waardedaling",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig met 0,88. Stap 1: 12% van €15.000 = 0,12 × 15.000 = €1.800. Stap 2: €15.000 − €1.800 = €13.200.",
        "distractorExplanations": {
          "0": "Goed! 12% van 15.000 = 1.800. Nieuwe waarde: 15.000 − 1.800 = €13.200.",
          "1": "Veelgemaakte fout: 8% berekenen. 8% van 15.000 = 1.200, 15.000 − 1.200 = 13.800. Maar het is 12%.",
          "2": "Veelgemaakte fout: 20% berekenen. 20% van 15.000 = 3.000. Maar €3.000 is de korting bij 20%, niet de waarde.",
          "3": "Veelgemaakte fout: optellen in plaats van aftrekken. Bij waardedaling trek je af: 15.000 − 1.800 = 13.200."
        }
      }
    },
    {
      "id": "GET-PROC-AFNAME-004",
      "familyId": "GET-PROC-AFNAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_afname",
      "questionType": "multiple_choice",
      "question": "Een winkel verlaagt alle prijzen met 35%. Een jas kostte €80. Wat is de nieuwe prijs?",
      "options": [
        "€52",
        "€45",
        "€28",
        "€108"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "proc_afname_uitverkoop",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Strategie: vermenigvuldig met 0,65. Stap 1: 35% van €80 = 0,35 × 80 = €28. Stap 2: €80 − €28 = €52. Of: €80 × 0,65 = €52.",
        "distractorExplanations": {
          "0": "Goed! 35% van 80 = 28. Nieuwe prijs: 80 − 28 = €52.",
          "1": "Veelgemaakte fout: 35 aftrekken. 80 − 35 = 45, maar 35% van 80 = 28, niet 35.",
          "2": "Veelgemaakte fout: alleen de korting geven. €28 is de korting, niet de nieuwe prijs.",
          "3": "Veelgemaakte fout: optellen. 80 + 28 = 108. Bij korting trek je af."
        }
      }
    }
  ]
}
